import { render, staticRenderFns } from "./bgys-asset-group-category-asset-group-criticality-form.vue?vue&type=template&id=74b52228"
import script from "./bgys-asset-group-category-asset-group-criticality-form.vue?vue&type=script&lang=js"
export * from "./bgys-asset-group-category-asset-group-criticality-form.vue?vue&type=script&lang=js"
import style0 from "./bgys-asset-group-category-asset-group-criticality-form.vue?vue&type=style&index=0&id=74b52228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports